import React from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Worth from './worth'
import { IWorth, IState } from '@/components/poizon-fission/types'

/**
 * 动态列
 * @param props 动态列类型
 * @returns React 元素
 */
export default function DynamicColumns(
  props: { type: 'twoThirds' | 'oneThird' | 'aHalf'; columns: IWorth[] } & IState
) {
  const { type, columns, flow } = props
  let classNameType = ''
  // 三分之二
  if (type === 'twoThirds') {
    classNameType = 'twoThirdsDynamic'
    // 三分之一列
  } else if (type === 'oneThird') {
    classNameType = 'oneThirdDynamic'
    // 二分之一列
  } else {
    classNameType = 'aHalfDynamic'
  }

  return (
    <div className={classnames(styles[classNameType], styles[flow])}>
      {columns.map((item, index) => (
        <Worth key={index} {...item} flow={flow} />
      ))}
    </div>
  )
}
